import { Button, TextField, Container, Typography } from "@mui/material";
import axios from "axios";
import logger from "../utilitis/logger";
import { useEffect, useState } from "react";
import FormHelperText from "@mui/material/FormHelperText";
import CustomCard from "../styleComp/CustomCard";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import { useNavigate } from "react-router-dom";

export default function FilePriority() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [alert, setAlert] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { validationPage } = useErrValidate();
  const navigate = useNavigate();

  useEffect(() => {
    validationPage("general");
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      setAlert("נא לבחור קובץ");
      return;
    }

    setAlert("");

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post("/uploadFiles/upload_file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setTimeout(() => {
        setSuccessMessage("הקובץ הועלה בהצלחה");
      }, 3000);
      setSuccessMessage("");
      setSelectedFile(null);
    } catch (error) {
      logger.error("התקבלה שגיאהץ נא לוודא ששם הקובץ באנגלית", error);
      setTimeout(() => {
        setAlert("התקבלה שגיאה. אנא ודא ששם הקובץ באנגלית");
      }, 5000);
      setAlert("");
      if (error.response.status == 403) {
        navigate("/");
      }
    }
  };

  return (
    <Container>
      <CustomCard overflowCard={"scroll"}>
        <Typography variant="h6" align="left" mb={3}>
          העלה קובץ
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            type="file"
            variant="outlined"
            fullWidth
            onChange={handleFileChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          {alert && (
            <FormHelperText style={{ color: "red" }}>{alert}</FormHelperText>
          )}
          {successMessage && (
            <FormHelperText style={{ color: "green" }}>
              {successMessage}
            </FormHelperText>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginTop: "16px" }}
          >
            העלה קובץ
          </Button>
        </form>
      </CustomCard>
    </Container>
  );
}
